<template>
  <div>
    <v-card elevation="0">
      <v-card-text>
        <v-form v-model="form_validate_status" ref="form">
          <v-card-title>
            {{ $t("menu.applicant_info_medicine") }}
          </v-card-title>
          <v-divider color="white"></v-divider>
          <div class="title1">
            {{ $t("applicantInfo_medical.educational_background") }}
          </div>
          <v-row>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="diplomaType"
                v-bind:label="
                  $t('applicantInfo_medical.educational_background')
                "
                v-bind:item-text="(item) => objectTranslator(item, 'name')"
                v-bind:items="diplomaType_group"
                v-bind:item-value="(item) => item.diplomaType_value"
                outlined
                dense
              ></v-autocomplete>
            </v-col>
          </v-row>
          <div class="title1">
            {{ $t("applicantInfo_medical.standard_academic_test") }}
          </div>
          <div class="title2">
            {{ $t("applicantInfo_medical.SAT2_subject_test") }}
          </div>
          <v-row>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="SAT2_biology_score"
                v-bind:label="$t('applicantInfo_medical.biology')"
                v-bind:placeholder="$t('applicantInfo_medical.biology')"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="SAT2_chemistry_score"
                v-bind:label="$t('applicantInfo_medical.chemistry')"
                v-bind:placeholder="$t('applicantInfo_medical.chemistry')"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="SAT2_physics_score"
                v-bind:label="$t('applicantInfo_medical.physics')"
                v-bind:placeholder="$t('applicantInfo_medical.physics')"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="SAT2_math_score"
                v-bind:label="$t('applicantInfo_medical.mathematics')"
                v-bind:placeholder="$t('applicantInfo_medical.mathematics')"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="3">
              <DateSelectCard
                v-model="SAT2_testDate"
                v-bind:label="$t('applicantInfo_medical.test_date')"
              />
            </v-col>
          </v-row>

          <div class="title2">
            {{ $t("applicantInfo_medical.bioMedical_admission_test") }}
          </div>
          <v-row>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="BMAT_section1"
                v-bind:label="$t('applicantInfo_medical.section1')"
                v-bind:placeholder="$t('applicantInfo_medical.section1')"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="BMAT_section2"
                v-bind:label="$t('applicantInfo_medical.section2')"
                v-bind:placeholder="$t('applicantInfo_medical.section2')"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="BMAT_section3"
                v-bind:label="$t('applicantInfo_medical.section3')"
                v-bind:placeholder="$t('applicantInfo_medical.section3')"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="3">
              <DateSelectCard
                v-model="BMAT_testDate"
                v-bind:label="$t('applicantInfo_medical.test_date')"
              />
            </v-col>
          </v-row>

          <div class="title1">
            {{ $t("applicantInfo_medical.SPOT_score") }}
          </div>
          <v-row>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="SPOT_score"
                v-bind:label="$t('applicantInfo_medical.SPOT_score')"
                v-bind:placeholder="$t('applicantInfo_medical.SPOT_score')"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <DateSelectCard
                v-model="SPOT_testDate"
                v-bind:label="$t('applicantInfo_medical.test_date')"
              />
            </v-col>
          </v-row>

          <div class="title1">
            {{ $t("applicantInfo_medical.english_proficiency_test") }}
          </div>
          <v-row>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="TOEFL_paper_score"
                v-bind:label="$t('applicantInfo_medical.TOEFL_paper_based')"
                v-bind:placeholder="
                  $t('applicantInfo_medical.TOEFL_paper_based')
                "
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="TOEFL_computer_score"
                v-bind:label="$t('applicantInfo_medical.TOEFL_computer_based')"
                v-bind:placeholder="
                  $t('applicantInfo_medical.TOEFL_computer_based')
                "
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="TOEFL_internet_score"
                v-bind:label="$t('applicantInfo_medical.TOEFL_internet_based')"
                v-bind:placeholder="
                  $t('applicantInfo_medical.TOEFL_internet_based')
                "
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <DateSelectCard
                v-model="TOEFL_testDate"
                v-bind:label="$t('applicantInfo_medical.test_date')"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="IELTS_score"
                v-bind:label="$t('applicantInfo_medical.IELTS_academic_module')"
                v-bind:placeholder="
                  $t('applicantInfo_medical.IELTS_academic_module')
                "
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <DateSelectCard
                v-model="IELTS_testDate"
                v-bind:label="$t('applicantInfo_medical.test_date')"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="CUTEP_score"
                v-bind:label="$t('applicantInfo_medical.CU_TEP')"
                v-bind:placeholder="$t('applicantInfo_medical.CU_TEP')"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <DateSelectCard
                v-model="CUTEP_testDate"
                v-bind:label="$t('applicantInfo_medical.test_date')"
              />
            </v-col>
          </v-row>
          <div class="title1">
            {{ $t("applicantInfo_medical.personal_statement") }}
          </div>
          <v-row>
            <v-col cols="12" md="12">
              <v-textarea
                v-model="personalStatement"
                v-bind:label="$t('applicantInfo_medical.personal_statement')"
                outlined
              ></v-textarea>
              <!-- <span>{{ totalWord }} characters</span> -->
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn block elevation="0" color="success" @click="validate()">{{
          $t("menu.save")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { objectTranslator, inlineTranslator } from "@/helper/translator";
import DateSelectCard from "@/components/info_cards/DateSelect";
import ApplicantInfoProvider from "@/services/applicant_info";

const applicantInfoService = new ApplicantInfoProvider();

export default {
  name: "ApplicantInfoMedical",
  data: function () {
    return {
      loading: false,
      form_validate_status: null,

      terms: [3, 4, 5, 6],

      diplomaType_group: [
        {
          diplomaType_value: "ม.6 หรือ เทียบเท่า",
          name_TH: "มัธยมศึกษาปีที่ 6 หรือ เทียบเท่ากระทรวงศึกษาธิการ",
          name_EN:
            "Matthayom 6 or equivalent to Grade 12 as specified by the Ministry of Education",
        },
        {
          diplomaType_value: "Grade 12",
          name_TH: "ระดับ Grade 12 ตามระบบการศึกษาแบบอเมริกัน",
          name_EN: "Grade 12 according to American Education System",
        },
        {
          diplomaType_value: "Year 13",
          name_TH: "ระดับ Year 13 ตามระบบการศึกษาแบบอังกฤษ",
          name_EN: "Year 13 according to the British education system",
        },
      ],

      totalWord: null,

      diplomaType: null,

      SAT2_biology_score: null,
      SAT2_chemistry_score: null,
      SAT2_physics_score: null,
      SAT2_math_score: null,
      SAT2_testDate: null,

      BMAT_section1: null,
      BMAT_section2: null,
      BMAT_section3: null,
      BMAT_testDate: null,

      SPOT_score: null,
      SPOT_testDate: null,

      TOEFL_paper_score: null,
      TOEFL_computer_score: null,
      TOEFL_internet_score: null,
      TOEFL_testDate: null,
      IELTS_score: null,
      IELTS_testDate: null,
      CUTEP_score: null,
      CUTEP_testDate: null,

      personalStatement: null,
    };
  },
  components: { DateSelectCard },

  methods: {
    objectTranslator,
    inlineTranslator,

    async fetch_data() {
      await this.$store.dispatch("auth/getSidebarStatus");
      const uid = localStorage.getItem("uid");
      const data = await applicantInfoService.getApplicantInfoMedical(uid);

      this.diplomaType = data.DIPLOMA_TYPE;

      this.SAT2_biology_score = data.SAT_2_BIO_SCORE;
      this.SAT2_chemistry_score = data.SAT_2_CHEM_SCORE;
      this.SAT2_physics_score = data.SAT_2_PHY_SCORE;
      this.SAT2_math_score = data.SAT_2_MATH_SCORE;
      this.SAT2_testDate = data.SAT_2_TEST_DATE;

      this.BMAT_section1 = data.BMAT_SECTION_1_SCORE;
      this.BMAT_section2 = data.BMAT_SECTION_2_SCORE;
      this.BMAT_section3 = data.BMAT_SECTION_3_SCORE;
      this.BMAT_testDate = data.BMAT_TEST_DATE;

      this.SPOT_score = data.SPOT_SCORE;
      this.SPOT_testDate = data.SPOT_TEST_DATE;

      this.TOEFL_paper_score = data.TOEFL_PBT_SCORE;
      this.TOEFL_computer_score = data.TOEFL_CBT_SCORE;
      this.TOEFL_internet_score = data.TOEFL_IBT_SCORE;
      this.TOEFL_testDate = data.TOFEL_TEST_DATE;
      this.IELTS_score = data.IELTS_SCORE;
      this.IELTS_testDate = data.IELTS_TEST_DATE;
      this.CUTEP_score = data.CU_TEP_SCORE;
      this.CUTEP_testDate = data.CU_TEP_TEST_DATE;

      this.personalStatement = data.PERSONAL_STATEMENT;
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.save();
      }
    },
    async save() {
      this.loading = true;
      const uid = localStorage.getItem("uid");
      const response = await applicantInfoService
        .setApplicantInfoMedical(
          {
            DIPLOMA_TYPE: this.diplomaType !== "" ? this.diplomaType : null,

            SAT_2_BIO_SCORE:
              this.SAT2_biology_score !== "" ? this.SAT2_biology_score : null,
            SAT_2_CHEM_SCORE:
              this.SAT2_chemistry_score !== ""
                ? this.SAT2_chemistry_score
                : null,
            SAT_2_PHY_SCORE:
              this.SAT2_physics_score !== "" ? this.SAT2_physics_score : null,
            SAT_2_MATH_SCORE:
              this.SAT2_math_score !== "" ? this.SAT2_math_score : null,
            SAT_2_TEST_DATE:
              this.SAT2_testDate !== "" ? this.SAT2_testDate : null,

            BMAT_SECTION_1_SCORE:
              this.BMAT_section1 !== "" ? this.BMAT_section1 : null,
            BMAT_SECTION_2_SCORE:
              this.BMAT_section2 !== "" ? this.BMAT_section2 : null,
            BMAT_SECTION_3_SCORE:
              this.BMAT_section3 !== "" ? this.BMAT_section3 : null,
            BMAT_TEST_DATE:
              this.BMAT_testDate !== "" ? this.BMAT_testDate : null,

            SPOT_SCORE: this.SPOT_score !== "" ? this.SPOT_score : null,
            SPOT_TEST_DATE:
              this.SPOT_testDate !== "" ? this.SPOT_testDate : null,

            TOEFL_PBT_SCORE:
              this.TOEFL_paper_score !== "" ? this.TOEFL_paper_score : null,
            TOEFL_CBT_SCORE:
              this.TOEFL_computer_score !== ""
                ? this.TOEFL_computer_score
                : null,
            TOEFL_IBT_SCORE:
              this.TOEFL_internet_score !== ""
                ? this.TOEFL_internet_score
                : null,
            TOFEL_TEST_DATE:
              this.TOEFL_testDate !== "" ? this.TOEFL_testDate : null,
            IELTS_SCORE: this.IELTS_score !== "" ? this.IELTS_score : null,
            IELTS_TEST_DATE:
              this.IELTS_testDate !== "" ? this.IELTS_testDate : null,
            CU_TEP_SCORE: this.CUTEP_score !== "" ? this.CUTEP_score : null,
            CU_TEP_TEST_DATE:
              this.CUTEP_testDate !== "" ? this.CUTEP_testDate : null,

            PERSONAL_STATEMENT:
              this.personalStatement !== "" ? this.personalStatement : null,
          },
          uid
        )
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.loading = false;
        });

      if (response && response.status)
        this.$toasted.success(this.$t("toasted.save_successfully"));
      else this.$toasted.error(this.$t("toasted.cannot_save"));
      this.fetch_data();
      this.loading = false;
    },
  },
  created() {
    this.fetch_data();
  },
};
</script>
<style scoped>
.title1 {
  color: purple;
  /* text-decoration: underline; */
  font-size: 20px;
  margin-top: 30px;
  margin-bottom: 20px;
}
.title2 {
  font-size: 20px;
  margin-bottom: 20px;
}
</style>
